// extracted by mini-css-extract-plugin
module.exports = {"body":"TransferOwnershipModal_body__ZoTtd","buttons":"TransferOwnershipModal_buttons__ZTi2Z","disabled":"TransferOwnershipModal_disabled__1TTC-"};